import { render, staticRenderFns } from "./Edit-colaborador.vue?vue&type=template&id=611e67e0&"
import script from "./Edit-colaborador.vue?vue&type=script&lang=js&"
export * from "./Edit-colaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports